import React from "react";

import imageOptions from "./data/images";

export default function PostImages({ img, onChange }) {
  return (
    <div>
      <label style={{ marginBottom: "8px", display: "block" }}>
        <b>Post Image</b>
      </label>
      <div className="post-images">
        {imageOptions
          .filter((f) => f.ig)
          .map((image, i) => (
            <button
              onClick={() => onChange(image.id)}
              key={image.id}
              className={`post-image${img === image.id ? " active" : ""}`}
            >
              <img src={image.src} />
            </button>
          ))}
      </div>
    </div>
  );
}
